"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pshowUnit = void 0;
var uint8array_utils_1 = require("@harmoniclabs/uint8array-utils");
var type_system_1 = require("../../type_system/index.js");
var phoist_1 = require("../phoist.js");
var plam_1 = require("../plam.js");
var std_1 = require("../std/index.js");
exports.pshowUnit = (0, phoist_1.phoist)((0, plam_1.plam)(type_system_1.unit, type_system_1.bs)(function (_) { return (0, std_1.pByteString)((0, uint8array_utils_1.fromAscii)("()")); }));
